let hm = document.createElement('script');
hm.src = '//hm.baidu.com/hm.js?6b82c15e44f810b130c2eb92b0b36483';
let s = document.getElementsByTagName('script')[0];
s.parentNode.insertBefore(hm, s);
